import { zonedEndOfDay, zonedStartOfDay } from "@/lib/timezone";

/**
 * The default lessons window, in days. The schedule fetches this window
 * once and filters client-side, so it is the single source of truth for
 * `GET /api/lessons` in the student UI.
 */
export const DEFAULT_WINDOW_DAYS = 14;

export interface LessonsWindow {
  /** ISO-8601 UTC datetime, inclusive. */
  from: string;
  /** ISO-8601 UTC datetime, inclusive. */
  to: string;
}

/**
 * The default `from`/`to` window for `GET /api/lessons` (issue #271).
 *
 * `ScheduleScreen` and `ClassDetailScreen` both build their range with
 * this helper, so they read (and optimistically update) the **same**
 * react-query cache entry. Keep it deterministic for a given `now`: the
 * range is day-aligned, so two mounts on the same day share a key.
 */
export function defaultLessonsWindow(now: Date = new Date()): LessonsWindow {
  const windowEnd = new Date(
    now.getTime() + DEFAULT_WINDOW_DAYS * 24 * 60 * 60 * 1000,
  );
  return {
    from: zonedStartOfDay(now).toISOString(),
    to: zonedEndOfDay(windowEnd).toISOString(),
  };
}
